<template>
    <KRHPPaigutus>
      <template #pais>
        <Ligipaasetavus/>
      </template>
    </KRHPPaigutus>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import Ligipaasetavus from "@/components/ligipaasetavus/Ligipaasetavus.vue";
import KRHPPaigutus from "@/components/uldine/KRHPPaigutus.vue";

export default defineComponent({
    name: 'LigipaasetavusKrhpPaigutusLeht',
    components: { KRHPPaigutus, Ligipaasetavus }
})
</script>

<style scoped>

</style>